interface IOSSImgCompressOptions {
  /** oss缩放图片宽度 */
  width?: number;
  /** oss缩放图片高度 */
  height?: number;
  /** 压缩质量，默认90 */
  quality?: boolean | number;
  /** 转换格式 */
  format?: 'jpg' | 'png' | 'webp' | 'jpeg';
  /** 是否剪裁 */
  cut?: boolean;
  /** 是否开启webp */
  webp?: boolean;
}

/**
 * OSS/CDN 图片处理 => 剪裁/格式转换/压缩
 * @description  文档 https://help.aliyun.com/zh/oss/user-guide/adjust-image-quality?spm=a2c4g.11186623.0.0.38e91a0aEd6g0Y
 * @param {string} src 图片地址
 * @param {number} opt.width 图片宽度
 * @param {number} opt.height 图片高度
 * @param {boolean | number} opt.quality 图片质量 (仅对 JPG 和 WEBP 的图片有效)
 * @param {boolean} opt.webp 是否使用webp格式
 * @param {'jpg'|'png'} opt.format 格式转换
 * @param {boolean} opt.cut 是否剪裁
 * @returns
 */

export default function ossImgCompress(src: string, opt: IOSSImgCompressOptions) {
  let imgSrc = '';
  if (src && src !== '' && opt) {
    imgSrc = src;
    try {
      if (['res.insta360.com', 'static.insta360.com', '.aliyuncs.com/static/'].find((url) => src.indexOf(url) !== -1)) {
        const url = new URL(src);
        const search = new URLSearchParams(url.search);
        const config = ['image', 'auto-orient,1'];
        // 图片宽高修改(缩放)
        if (opt.width && opt.height) {
          // 是否剪裁(宽高同时设置时可选择是否居中剪裁)
          config.push(`resize,${opt.cut ? 'm_fill' : 'm_lfit'},w_${opt.width},h_${opt.height}`);
        } else if (opt.width || opt.height) {
          // 设置宽度，高度自适应
          if (opt.width) {
            config.push(`resize,m_lfit,w_${opt.width}`);
          }
          // 设置高度，宽度自适应
          if (opt.height) {
            config.push(`resize,m_lfit,h_${opt.height}`);
          }
        }

        // 图片格式转换
        if (opt.webp && canUseWebp(src)) {
          config.push(`format,webp`);
        } else if (opt.format) {
          config.push(`format,${opt.format}`);
          // jep格式图片开启渐进显示
          if (opt.format === 'jpg') {
            config.push(`interlace,1`);
          }
        }

        // 图片压缩
        if (opt.quality) {
          config.push(`quality,q_${typeof opt.quality === 'number' ? opt.quality : '90'}`);
        }

        // 将配置设置到URL中
        if (config.length > 2) {
          search.set('x-oss-process', config.join('/'));
          imgSrc = url.origin + url.pathname + '?' + search.toString();
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
  return imgSrc;
}

export const canUseWebp = (src: string) => {
  if (typeof window === 'undefined') return false;
  return (
    !!src &&
    !src.includes('webp') &&
    ['.jpeg', '.jpg', '.png'].some((key) => src.includes(key)) &&
    window.__NEXT_DATA__.props?.pageData?.runtimeInject?.webp
  );
};
